import Api from './api';
import { PageResponse } from '@/schema/page';
import {
  IssueReportCreate,
  IssueReportDetail,
  IssueReportQuery,
  IssueReportSummary,
  IssueReportUpdate,
} from '@/schema/issueReport';

const IssueReportApi = {
  create(data: IssueReportCreate) {
    return Api.post<string>('/issue-reports', data);
  },

  getAll(page: number, size: number, query: IssueReportQuery) {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    Object.entries(query).forEach(([key, value]) => {
      if (value) params.set(key, String(value));
    });
    return Api.get<PageResponse<IssueReportSummary>>(`/issue-reports?${params.toString()}`);
  },

  getById(id: string) {
    return Api.get<IssueReportDetail>(`/issue-reports/${id}`);
  },

  update(id: string, data: IssueReportUpdate) {
    return Api.put<IssueReportDetail>(`/issue-reports/${id}`, data);
  },

  /** Superadmin only — triage is open to admins, throwing the report away is not. */
  delete(id: string) {
    return Api.delete<void>(`/issue-reports/${id}`);
  },

  /** Rendered via an object URL — the endpoint needs the auth header, so no plain <img src>. */
  async getScreenshot(id: string) {
    const response = await Api.axios.get(`/issue-reports/${id}/screenshot`, { responseType: 'blob' });
    return response.data as Blob;
  },
};

export default IssueReportApi;
